// TODO: doc!
const last = (arr: any[]): any => arr.slice(- 1)[0];
export default last
